import React from 'react';
import { Paper, Typography, Box, Divider } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';

const ResultsDisplay = ({ result }) => {
  if (!result) {
    return (
      <Paper elevation={5} sx={{ mt: 4, p: 3, backgroundColor: 'warning.dark' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <WarningIcon sx={{ fontSize: 40, mr: 2, color: 'white' }} />
          <Typography variant="h5" color="white">
            No profitable combination found. Please ensure you have at least one of each item type (seed, animal, bed) and that their grades can be matched.
          </Typography>
        </Box>
      </Paper>
    );
  }

  const totalProfitPerHour = result.profitPerHour * result.totalBeds;
  const totalProfitPerDay = totalProfitPerHour * 24;

  return (
    <Paper elevation={5} sx={{ mt: 4, p: 3, backgroundColor: 'success.dark' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <CheckCircleIcon sx={{ fontSize: 40, mr: 2, color: 'white' }}/>
        <Typography variant="h4" component="h2" color="white">
          Optimal Strategy Found!
        </Typography>
      </Box>
      <Divider sx={{ my: 2, borderColor: 'rgba(255, 255, 255, 0.2)' }} />
      <Typography variant="h6" component="p" color="white">
        To maximize your profit, dedicate your <strong>{result.totalBeds} bed(s)</strong> to this cycle:
      </Typography>
      <ul>
        <li><Typography color="white"><strong>Grow:</strong> {result.seed}</Typography></li>
        <li><Typography color="white"><strong>On:</strong> {result.bed}</Typography></li>
        <li><Typography color="white"><strong>To Feed:</strong> {result.animal}</Typography></li>
      </ul>
      <Divider sx={{ my: 2, borderColor: 'rgba(255, 255, 255, 0.2)' }} />
      <Box sx={{ mt: 2, p: 2, backgroundColor: 'rgba(0,0,0,0.2)', borderRadius: 1 }}>
         <Typography variant="h5" component="p" align="center" color="white">
            Total Profit Rate: <strong>{totalProfitPerHour.toLocaleString()}</strong> Biopoints / hour
         </Typography>
         <Typography variant="body1" align="center" color="white">
            That's ~<strong>{totalProfitPerDay.toLocaleString()}</strong> Biopoints per day!
         </Typography>
      </Box>
    </Paper>
  );
};

export default ResultsDisplay;